//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes material
import Typography from '@material-ui/core/Typography';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Componentes
import ResultadoQuestao from './ResultadoQuestao';
//Models
import AvaliacaoSecao from '../../models/AvaliacaoSecao';
import Avaliacao from '../../models/Avaliacao';
//Estilos
import ResultadoStyle from '../../styles/ResultadoStyle';

/**
 * Renderiza uma lista de questões de acordo com os dados das seções
 * @param {Array<AvaliacaoSecao>} secoes Lista de seções a serem exibidas
 * @param {Array<Avaliacao>} avaliacoes Dados das avaliações a serem exibidas
 * @returns {Object} Retorna a lista de componentes renderizados
 */
function renderizarQuestoes(secoes, avaliacoes) {
    return secoes[0].questoes.map((questao, indice) => 
        <ResultadoQuestao key={questao.id} respostas={secoes.map(secao => secao.questoes[indice])} avaliacoes={avaliacoes} />
    );
}

/**
 * Componente para exibição dos dados da seção e das questões associadas
 * @param {Object} props Propriedades do componente
 * @param {Array<AvaliacaoSecao>} props.secoes Seções a serem exibidas
 * @param {Array<Avaliacao>} props.avaliacoes Dados das avaliações a serem exibidas
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoSecao({ secoes, avaliacoes, classes }) {
    if (secoes.length === 0) return 'Nenhuma seção encontrada';

    return (
        <TableBody className={classes.corpoTabela}>
            <TableRow className={classes.tituloSecao}>
                <TableCell colSpan={secoes.length}>
                    <Typography variant="h2" className={classes.secao} >{secoes[0].titulo}</Typography>
                </TableCell>
            </TableRow>
            { renderizarQuestoes(secoes, avaliacoes) }
        </TableBody>
    );
}

ResultadoSecao.propTypes = {
    /** Dados das seções a serem exibidas */
    secoes: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoSecao)).isRequired,
    /** Dados das avaliações a serem exibidas */
    avaliacoes: PropTypes.arrayOf(PropTypes.instanceOf(Avaliacao)).isRequired,
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoSecao);